export default __webpack_public_path__ + "static/media/dino_standup.23817471.png";